import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState, useContext, useRef } from "react"

import Clock from "../../../components/Common/Clock";
import Button from "../../../components/Common/Button";
import dataContext from "../../../context/dataContext";
// import SoundFooter from "../../../components/Common/SoundFooter"

import mainContext from "../../../context/mainContext";

import styles from "./style.module.css"
import srcWave from "./soundWave.png"
import audioPlayer from '../../../components/api/audioPlayerWrapper';
import { PitchShifter } from '../../../dist/soundtouch';

const audioCtxSetRate = new (window.AudioContext || window.webkitAudioContext)();
console.log("🚀 ~ audioCtx:", audioCtxSetRate)
const gainNode = audioCtxSetRate.createGain();
let shifter;
console.log("🚀 ~ shifter:", shifter)

const loadSource = function (url, tempo) {
  return new Promise((resolve, reject) => {

    if (shifter) {
      console.log("🚀 ~ returnnewPromise ~ shifter:", shifter)
      shifter.off();
    }
    console.log("🚀 ~ returnnewPromise ~ shifter:", shifter)
    fetch(url)
      .then((response) => response.arrayBuffer())
      .then((buffer) => {
        console.log('have array buffer');
        audioCtxSetRate.decodeAudioData(buffer, (audioBuffer) => {
          console.log('decoded the buffer');
          shifter = new PitchShifter(audioCtxSetRate, audioBuffer, 16384);
          shifter.tempo = tempo;
          shifter.pitch = "1.0";
          shifter.on('play', (detail) => {
            console.log("🚀 ~ shifter.on ~ detail:", detail)
            console.log(`timeplayed: ${detail.timePlayed}`);
            console.log("🚀 ~ shifter.on ~ detail.formattedTimePlayed:", detail.formattedTimePlayed)
            console.log("🚀 ~ shifter.on ~ detail.percentagePlayed:", detail.percentagePlayed)
          });
          console.log("🚀 ~ audioCtxSetRate.decodeAudioData ~ shifter.formattedDuration:", shifter.formattedDuration);
          resolve(shifter.formattedDuration)
          // playBtn.removeAttribute('disabled');
        });
      }).catch((err) => {
        console.log("🚀 ~ .then ~ err:", err)
        reject(err);
      });
  });
};

let is_playing = false;
const playAUD = function () {
  console.log(shifter)
  shifter.connect(gainNode);
  gainNode.connect(audioCtxSetRate.destination);
  audioCtxSetRate.resume().then(() => {
    is_playing = true;
    // this.setAttribute('disabled', 'disabled');
  });
};

const pauseAUD = function (playing = false) {
  console.log("🚀 ~ pauseAUD ~ shifter:", shifter)
  if (shifter) {
    shifter.disconnect();
    is_playing = playing;
  }
};
const increaseRateAUD = function (increase) {
  console.log("🚀 ~ increaseRateAUD ~ increase:", increase)
  shifter.tempo = increase;
}

function Training({ submitFunc }) {
  const [loading, setLoading] = useState(false);
  const [isiPhone, setisiPhone] = useState(window.buildType == "iPhone");//useState(true)
  const { userDetails } = useContext(dataContext)
  const tr = userDetails.TR
  const { state } = useLocation();
  const [lpm, setLpm] = useState(tr.length > 0 ? state.chosenLpm ? state.chosenLpm : tr[tr.length - 1].value : 30)
  const [fileName, setfileName] = useState(pickFile(lpm));
  const [musicIsLoad, setMusicIsLoad] = useState(false);
  const [playing, setPlaying] = useState(false);
  const navigate = useNavigate()
  const { loader: { setLoaderFetch }, header: { setPageName }, TR_duration } = useContext(mainContext)



  // Refs for the audio element
  const audioRef = useRef(null);



  useEffect(() => {
    if (state.from == "freestyle") {
      setPageName("SET RATE");
    } else if (state.from == "pushup start") {
      setPageName("LPM SETUP");
    } else {
      setPageName("FINE TUNE");
    }
    document.addEventListener("pause", onGoBackground);
    document.addEventListener("visibilitychange", onGoBackground);

    return () => {
      setPageName("");
      document.removeEventListener("pause", onGoBackground);
      console.log("removing event listener visibilitychange");
      document.removeEventListener("visibilitychange", onGoBackground);
      handleStop();
    }
  }, []);

  useEffect(() => {
    let updatedFilePath = pickFile(lpm)
    console.log("🚀 ~ useEffect ~ lpm:", lpm)
    console.log("🚀 ~ useEffect ~ updatedFilePath:", updatedFilePath)
    setfileName(updatedFilePath);

  }, [lpm]);


  useEffect(() => {

    console.log("🚀 ~ Training ~ fileName:", fileName)

  }, [fileName])

  useEffect(() => {
    if (loading) {
      setLoaderFetch(true);
    } else {
      setLoaderFetch(false);
    }
  }, [loading])

  function pickFile(lpm) {
    return lpm < 20 ? 10 : lpm < 60 ? 30 : 80;
  }


  function onPlay() {
    console.log("🚀 ~ onPlay ~ musicIsLoad:", musicIsLoad)

    if (!musicIsLoad) {
      handlePlay(fileName, lpm)//sending the state, it is update for sure here
    } else {
      handleResume()
    }
  }

  function onPause() {
    handlePause()
  }

  const onGoBackground = () => {
    console.log("🚀 ~ onGoBackground ~ onGoBackground:", onGoBackground)
    if (window.cordovaOn) {
      handlePause()
    } else {

      if (document.visibilityState === 'hidden') {
        console.log("Browser tab is now in the background");
        handlePause()
      } else if (document.visibilityState === 'visible') {
        console.log("Browser tab is now in the foreground");
      }
    }
  }

  const handlePlay = (filePickName, expectedLpm) => {
    console.log("🚀 ~ handlePlay ~ expectedLpm:", expectedLpm);
    console.log("🚀 ~ handlePlay ~ filePickName:", filePickName);
    if (window.cordovaOn) {

      audioPlayer.play(`wush_${filePickName}_6min`).then(log => {
        console.log(log)
        console.log("inside play method:", { musicIsLoad, playing })
        setMusicIsLoad(true);
        setPlaying(true);
        let currentSpeed = expectedLpm / filePickName;
        console.log("🚀 ~ audioPlayer.play ~ currentSpeed:", currentSpeed)
        handleSetSpeed(currentSpeed)
      }).catch(err => console.error(err)).finally(() => {
      });
    } else {
      let currentSpeed = expectedLpm / filePickName;
      if (isiPhone) {
        setLoading(true);
        handlePause();
        loadSource(`../../../../audio/wush_${filePickName}_6min.mp3`, currentSpeed).then(() => {
          playAUD();
          // setLoadSoundtouchAudioFile(true);
          setMusicIsLoad(true);
          setPlaying(true);

        }).catch(err => console.error(err)).finally(() => {
          setLoading(false);
        });
      } else {

        const audioElement = audioRef.current;
        audioElement.src = `/audio/wush_${filePickName}_6min.mp3`;
        if (audioElement) {
          audioElement.play();
          console.log("🚀 ~ handlePlay ~ currentSpeed:", currentSpeed)
          audioElement.playbackRate = currentSpeed;
          // handleSetSpeed(currentSpeed)
          setMusicIsLoad(true);
          setPlaying(true);
          // startTempoIncrease();
        }
      };
    }
  };

  const handlePause = () => {
    console.log("🚀 ~ handlePause ~call  handlePause:", handlePause)
    if (window.cordovaOn) {

      audioPlayer.pause().then(log => {
        setPlaying(false);
        console.log(log)
      }).catch(err => console.error(err));
    } else {
      if (isiPhone) {
        pauseAUD();
        setPlaying(false);
      } else {
        const audioElement = audioRef.current;
        if (audioElement) {
          audioElement.pause();
          setPlaying(false);
        }
      }
    }
  };

  const handleResume = () => {
    if (window.cordovaOn) {
      // Cordova-based logic
      audioPlayer.resume().then(log => {
        setPlaying(true)
        console.log(log)
      }).catch(err => console.error(err));
    } else {
      // Web-based logic
      if (isiPhone) {
        playAUD();
        setPlaying(true)
      } else {
        const audioElement = audioRef.current;
        if (audioElement) {
          audioElement.play();
          setPlaying(true)
        }
      }
    }
  };

  // const handleStop = () => {
  //   audioPlayer.stop().then(log => {
  //     setPlaying(false);
  //     setMusicIsLoad(false);
  //     console.log("call to stop: ", log)
  //   }).catch(err => console.error(err));
  // };

  const handleStop = async () => {
    if (window.cordovaOn) {
      try {
        const log = await audioPlayer.stop();
        setPlaying(false);
        setMusicIsLoad(false);
        console.log("call to stop: ", log);
      } catch (err) {
        console.error(err);
      }
    } else {
      try {
        if (isiPhone) {
          pauseAUD();
          setPlaying(false);
          setMusicIsLoad(false);
        } else {
          const audioElement = audioRef.current;
          if (audioElement) {
            audioElement.pause();
            audioElement.currentTime = 0;
            setPlaying(false);
            setMusicIsLoad(false);
          }
        }
      } catch (error) {
        console.log("🚀 ~ handleStop ~ error:", error)

      }
    }
  };


  const handleSetSpeed = (speed) => {
    console.log("🚀 ~ handleSetSpeed ~ speed:", speed)
    if (window.cordovaOn) {

      audioPlayer.setSpeed(speed).then(log => {
        console.log("speed is set to:", log)
      }).catch(err => console.error(err));
    } else {
      if (isiPhone) {
        increaseRateAUD(speed);
      } else {
        const audioElement = audioRef.current;
        if (audioElement) {
          audioElement.playbackRate = speed;
        }
      }
    };
  }




  async function rapid(newLpm) {
    let currentLpm = lpm;
    setLpm(newLpm);
    state.chosenLpm = newLpm;
    let newSpeed = newLpm / fileName;
    if (currentLpm <= 19 && newLpm >= 20 || currentLpm <= 59 && newLpm >= 60 || currentLpm >= 20 && newLpm <= 19 || currentLpm >= 60 && newLpm <= 59) {
      // if (newSpeed >= 2 || newSpeed < 0.7) {
      console.log("entering to change file mode");
      let pickedFile = pickFile(newLpm);
      if (window.cordovaOn) {

        await audioPlayer.stop();
      } else {
        const audioElement = audioRef.current;
        if (audioElement) {
          audioElement.pause();
        }
      }
      setTimeout(() => {

        console.log("the playing state before calling to play() again: " + playing);
        // if (musicIsLoad) {
        if (playing) {
          // setTimeout(() => {
          //   console.log("time out is fire");
          //   handlePlay(pickedFile, newLpm);
          // }, 300)
          // newSpeed = newLpm / pickedFile;//TODO: 09/10/24
          handlePlay(pickedFile, newLpm);
        } else {
          setMusicIsLoad(false);
        }
      }, 300)
      // }
    } else {
      handleSetSpeed(newSpeed)

    }
  }

  function onComplete() {
    console.log("onComplete")
  }

  const freeStyleFuncs = {
    onPlay: onPlay, //will turn on the music + remove button and add footer
    onPause: onPause, //will pause the music + remove footer and add button
    rapid: rapid, // what to send when freeStyle false??
    onComplete: onComplete
  }

  const onclick = () => {
    state.chosenLpm = lpm;
    if (state.from === "freestyle") {
      navigate('/');
    } else if (state.from == "pushup start") {
      navigate("/train-reading/pushup", {
        state: { ...state, chosenLpm: lpm }
      });
    } else {
      submitFunc(state)
    }
  }

  return (
    <>
      {state.from == "pushup start" && <div style={{ textAlign: "center", paddingBottom: "1rem" }}> SETING BASELINE RATE</div>}
      <div className={`pages ${styles.container}`}>
        <Clock freeStyle={state.from == "freestyle" ? 1 : state.from == "pushup start" ? 2 : 3} time={TR_duration} funcs={freeStyleFuncs} initRapidValue={lpm} playStateFromAbove={playing} ></Clock>
        <div className="btnHolder">
          {
            playing ?
              <img alt="wave" src={srcWave} /> :
              state.from === "freestyle" ?
                <Button title="DONE" startFunction={onclick} /> :
                state.from === "pushup start" ?
                  <Button title="SET AND START" startFunction={onclick} /> :
                  <Button title="JUST RIGHT" startFunction={onclick} />

          }
        </div>
        {(!window.cordovaOn && !isiPhone) && (
          <audio ref={audioRef} src={`/audio/wush_${fileName}_6min.mp3`} preload="auto" />
        )}
      </div>
    </>
  );
}

export default Training;


